document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#member-primary-nav"); // Replace with your container's selector
  const currentElement = container?.querySelector(".current");

  if (currentElement) {
    const scrollLeft = currentElement.offsetLeft - container.offsetLeft;
    requestAnimationFrame(() => {
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#member-secondary-nav"); // Replace with your container's selector
  const currentElement = container?.querySelector(".current");

  if (currentElement) {
    const scrollLeft = currentElement.offsetLeft - container.offsetLeft;
    requestAnimationFrame(() => {
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const headings = document.querySelectorAll('h2.data-settings-screen');
    
    headings.forEach(function(heading) {
        // Create a wrapper div
        const wrapper = document.createElement('div');
        wrapper.className = 'data-settings-section';
        
        // Insert the wrapper before the heading
        heading.parentNode.insertBefore(wrapper, heading);
        
        // Move the heading into the wrapper
        wrapper.appendChild(heading);
        
        // Move all following elements into the wrapper until we hit another h2 or run out of siblings
        let nextElement = wrapper.nextElementSibling;
        while (nextElement && nextElement.tagName.toLowerCase() !== 'h2') {
            wrapper.appendChild(nextElement);
            nextElement = wrapper.nextElementSibling;
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Function to remove a tab
    function removeTab(tabSelector) {
        const tab = document.querySelector(tabSelector);
        if (tab) {
            tab.remove();
            console.log('Removed tab:', tabSelector);
        } else {
            console.log('Tab not found:', tabSelector);
        }
    }


    // Remove Recycle tab on Change Avatar page
    if (window.location.href.includes('change-avatar')) {
        removeTab('#bp-avatar-recycle');
    }
});


document.addEventListener('DOMContentLoaded', function() {
  // Create a regular expression to match the URL pattern
  var urlPattern = /\/members\/[^\/]+\/forums\//;

  // Check if the URL matches the pattern
  if (urlPattern.test(window.location.href)) {
      // Find the element with class "bp-priority-subnav-nav-items"
      var element = document.querySelector('.bp-priority-subnav-nav-items');
      
      // If the element exists, add the class "forums-menu" and reorder the list items
      if (element) {
          element.classList.add('forums-menu');
          
          // Get all list items
          var listItems = element.querySelectorAll('li');
          
          // Check if there are list items
          if (listItems.length > 0) {
              // Get the last list item
              var lastItem = listItems[listItems.length - 1];
              
              // Remove the last item from its current position
              element.removeChild(lastItem);
              
              // Insert the last item at the beginning of the list
              element.insertBefore(lastItem, element.firstChild);

              // After DOM manipulation, run the scrolling function
              const container = document.querySelector("#member-secondary-nav");
              const currentElement = container?.querySelector(".current");

              if (currentElement) {
                  const scrollLeft = currentElement.offsetLeft - container.offsetLeft;
                  requestAnimationFrame(() => {
                      container.scrollTo({
                          left: scrollLeft,
                          behavior: "smooth",
                      });
                  });
              }
          }
      }
  }
});